import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const UnavailableIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path
      fill="currentColor"
      d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1M4.85 6.265A9.167 9.167 0 0 0 12 21.167a9.13 9.13 0 0 0 5.734-2.019zM12 2.833a9.13 9.13 0 0 0-5.735 2.018l12.883 12.883A9.13 9.13 0 0 0 21.167 12 9.167 9.167 0 0 0 12 2.833"
    />
  </BaseIcon>
)
